import { Box } from "@chakra-ui/react";
import React, { useContext } from "react";
import { useDispatch } from "react-redux";
import { show } from "redux-modal";
import { useTheme } from "src/hooks/useTheme";
import { colors } from "src/theme";
import { FullServiceContext } from "./context";

const Help: React.FC = () => {
  const theme = useTheme();
  const { client } = useContext(FullServiceContext);
  const dispatch = useDispatch();

  const handleContactClick = () => {
    // open up email with alex@ and cc team@awaken.tax
    window.open(
      "mailto:vip@awaken.tax?cc=team@awaken.tax&subject=Help%20with%20Awaken",
      "_blank"
    );
  };

  const handleApplyClick = () => {
    dispatch(
      show("FeedbackModal", {
        hiddenDescription: "Full Service Application",
        customTitle: "Apply for Full Service",
        customBody:
          "In order to best help you, tell us a little bit about your needs and what you are looking for. We'll circle back as soon as possible.",
      })
    );
  };

  if (!client?.hasFullService) {
    // advertising full service
    return (
      <div
        onClick={handleApplyClick}
        style={{ width: "100%", cursor: "pointer", position: "relative" }}
      >
        <div
          style={{
            background: "linear-gradient(45deg, #FFD700, #FFA500)",
            marginBottom: 16,
            borderRadius: "8px",
            border: `1px solid ${theme.border}`,
            padding: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            {/* Overlapping profile images */}
            <div style={{ position: "relative" }}>
              <Box
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  background: "black",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i
                  className="fa-solid fa-crown"
                  style={{
                    color: colors.yellow50,
                    fontSize: "20px",
                  }}
                />
              </Box>
            </div>

            {/* Help text and contact button */}
            <div style={{ flex: 1 }}>
              <h3
                style={{
                  fontSize: "14px",
                  fontWeight: 600,
                  color: colors.black,
                  margin: 0,
                }}
              >
                Want help on your crypto taxes?
              </h3>
              <button
                style={{
                  color: colors.black,
                  fontSize: 14,
                  fontWeight: 500,
                  background: "none",
                  border: "none",
                  padding: 0,
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                Apply now
              </button>
            </div>

            <i
              style={{
                color: colors.black,
              }}
              className="fa-solid fa-chevron-right"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      onClick={handleContactClick}
      style={{ width: "100%", cursor: "pointer", position: "relative" }}
    >
      <div
        style={{
          background: theme.header,
          marginBottom: 16,
          borderRadius: "8px",
          border: `1px solid ${theme.border}`,
          padding: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          {/* Overlapping profile images */}
          <div style={{ position: "relative" }}>
            <img
              src="https://ca.slack-edge.com/T02BR92JZBK-U08EQC85EPK-6c44caa7f5cc-512"
              alt="Profile 2"
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                border: "2px solid white",
              }}
            />
          </div>

          {/* Help text and contact button */}
          <div style={{ flex: 1 }}>
            <h3
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: theme.background,
                margin: 0,
              }}
            >
              Your Full Service Team <i className="fa-solid fa-shield-halved" />
            </h3>
            <button
              onClick={handleContactClick}
              style={{
                color: theme.secondaryBackground,
                fontSize: 14,
                fontWeight: 500,
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
              }}
            >
              Alex <span style={{ color: theme.placeholder }}>|</span>{" "}
              vip@awaken.tax
            </button>
          </div>

          <i
            style={{
              color: theme.secondaryBackground,
            }}
            className="fa-solid fa-chevron-right"
          />
        </div>
      </div>
    </div>
  );
};

export default Help;
